"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("../../scss/cookieConsentSmallModalBody.scss");
require("react-toggle/style.css"); // for ES6 modulestext to htmlreact html to te
const react_1 = __importDefault(require("react"));
const react_markdown_1 = __importDefault(require("react-markdown"));
const useCookiesConsent_1 = require("../../hooks/useCookiesConsent");
const useMobileDetect_1 = __importDefault(require("../../hooks/useMobileDetect"));
function CookieConsentSmallModalBody() {
    var _a;
    const { config, intlLang } = (0, useCookiesConsent_1.useCookiesConsent)();
    const isMobile = (0, useMobileDetect_1.default)().isMobile();
    return (react_1.default.createElement("div", { className: `cookie-consent-small-modal-body ${isMobile && "mobile"}` },
        react_1.default.createElement("div", { className: "cookie-consent-small-description" },
            react_1.default.createElement(react_markdown_1.default, null, (_a = config.descriptionSmall) === null || _a === void 0 ? void 0 : _a[intlLang]))));
}
exports.default = CookieConsentSmallModalBody;
//# sourceMappingURL=CookieConsentSmallModalBody.js.map